//* Libraries imports
import React from "react";
import { Container } from "@mui/material";

//* Components Imports
import ScrollTransition from "components/ScrollTransition";

//* Styles Imports
import styles from "./styles.module.css";

function HowToRegisterSection() {
  return (
    <section
      id="how-to-register-section"
      data-testid="how-to-register-section"
      aria-label="Seção informativa sobre o passo a passo para cadastrar sua loja"
      className={styles.howToRegisterSection}
    >
      <Container
        id="how-to-register-container"
        data-testid="how-to-register-container"
        aria-label="Container do passo a passo de cadastro"
        maxWidth="xl"
      >
        <ScrollTransition
          id="how-to-register-title-transition"
          data-testid="how-to-register-title-transition"
          aria-label="Animação de entrada do título como cadastrar"
        >
          <h2
            id="how-to-register-title"
            data-testid="how-to-register-title"
            aria-label="Título: Como cadastrar sua loja"
            className={styles.sectionTitle}
          >
            <span className={styles.highlight}>Como Cadastrar</span> Sua Loja
          </h2>
          <div
            id="how-to-register-divider"
            data-testid="how-to-register-divider"
            aria-label="Linha decorativa amarela"
            className={styles.divider}
          />
        </ScrollTransition>

        <ol
          id="steps-list"
          data-testid="steps-list"
          aria-label="Lista ordenada com as quatro etapas de cadastro"
          className={styles.stepsList}
        >
          <ScrollTransition
            id="step-1-transition"
            data-testid="step-1-transition"
            aria-label="Animação da etapa 1: Acesse"
            delay={100}
          >
            <li
              id="step-item-1"
              data-testid="step-item-1"
              aria-label="Passo 1: Acesse o portal"
              className={styles.stepItem}
            >
              <div
                id="badge-1"
                data-testid="badge-1"
                aria-label="Etapa 1"
                className={styles.stepBadge}
              >
                1
              </div>
              <div
                id="text-wrapper-1"
                data-testid="text-wrapper-1"
                aria-label="Conteúdo da etapa 1"
                className={styles.stepTextWrapper}
              >
                <h3
                  id="step-title-1"
                  data-testid="step-title-1"
                  aria-label="Etapa Acesse"
                  className={styles.stepTitle}
                >
                  <span className={styles.highlight}>Acesse</span>
                </h3>
                <p
                  id="step-desc-1"
                  data-testid="step-desc-1"
                  aria-label="Descrição: Acesse painel.igoob.com.br e clique em CADASTRE SUA LOJA AGORA"
                  className={styles.stepDesc}
                >
                  Acesse{" "}
                  <a
                    id="step-cta-link"
                    data-testid="step-cta-link"
                    aria-label="Link para o painel do lojista"
                    href="https://painel.igoob.com.br"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.highlight}
                    style={{ textDecoration: "underline" }}
                  >
                    painel.igoob.com.br
                  </a>{" "}
                  e clique em <strong className={styles.highlight}>"CADASTRE SUA LOJA AGORA"</strong>.
                </p>
              </div>
            </li>
          </ScrollTransition>

          <ScrollTransition
            id="step-2-transition"
            data-testid="step-2-transition"
            aria-label="Animação da etapa 2: Dados"
            delay={200}
          >
            <li
              id="step-item-2"
              data-testid="step-item-2"
              aria-label="Passo 2: Preencha as informações"
              className={styles.stepItem}
            >
              <div
                id="badge-2"
                data-testid="badge-2"
                aria-label="Etapa 2"
                className={styles.stepBadge}
              >
                2
              </div>
              <div
                id="text-wrapper-2"
                data-testid="text-wrapper-2"
                aria-label="Conteúdo da etapa 2"
                className={styles.stepTextWrapper}
              >
                <h3
                  id="step-title-2"
                  data-testid="step-title-2"
                  aria-label="Etapa Dados"
                  className={styles.stepTitle}
                >
                  <span className={styles.highlight}>Dados</span>
                </h3>
                <p
                  id="step-desc-2"
                  data-testid="step-desc-2"
                  aria-label="Descrição: Preencha as informações solicitadas e valide o e-mail de confirmação."
                  className={styles.stepDesc}
                >
                  Preencha as informações solicitadas e valide o e-mail de confirmação.
                </p>
              </div>
            </li>
          </ScrollTransition>

          <ScrollTransition
            id="step-3-transition"
            data-testid="step-3-transition"
            aria-label="Animação da etapa 3: Senha"
            delay={300}
          >
            <li
              id="step-item-3"
              data-testid="step-item-3"
              aria-label="Passo 3: Gere sua senha"
              className={styles.stepItem}
            >
              <div
                id="badge-3"
                data-testid="badge-3"
                aria-label="Etapa 3"
                className={styles.stepBadge}
              >
                3
              </div>
              <div
                id="text-wrapper-3"
                data-testid="text-wrapper-3"
                aria-label="Conteúdo da etapa 3"
                className={styles.stepTextWrapper}
              >
                <h3
                  id="step-title-3"
                  data-testid="step-title-3"
                  aria-label="Etapa Senha"
                  className={styles.stepTitle}
                >
                  <span className={styles.highlight}>Senha</span>
                </h3>
                <p
                  id="step-desc-3"
                  data-testid="step-desc-3"
                  aria-label="Descrição: Gere sua senha de acesso ao painel administrativo."
                  className={styles.stepDesc}
                >
                  Gere sua senha de acesso ao painel administrativo.
                </p>
              </div>
            </li>
          </ScrollTransition>

          <ScrollTransition
            id="step-4-transition"
            data-testid="step-4-transition"
            aria-label="Animação da etapa 4: Configurações"
            delay={400}
          >
            <li
              id="step-item-4"
              data-testid="step-item-4"
              aria-label="Passo 4: Defina horários e escolha entre entrega própria ou iGooB Entregador"
              className={styles.stepItem}
            >
              <div
                id="badge-4"
                data-testid="badge-4"
                aria-label="Etapa 4"
                className={styles.stepBadge}
              >
                4
              </div>
              <div
                id="text-wrapper-4"
                data-testid="text-wrapper-4"
                aria-label="Conteúdo da etapa 4"
                className={styles.stepTextWrapper}
              >
                <h3
                  id="step-title-4"
                  data-testid="step-title-4"
                  aria-label="Etapa Configurações"
                  className={styles.stepTitle}
                >
                  <span className={styles.highlight}>Configurações</span>
                </h3>
                <p
                  id="step-desc-4"
                  data-testid="step-desc-4"
                  aria-label="Descrição: Defina horários e escolha entre entrega própria ou iGooB Entregador."
                  className={styles.stepDesc}
                >
                  Defina horários e escolha entre entrega própria ou iGooB Entregador.
                </p>
              </div>
            </li>
          </ScrollTransition>
        </ol>
      </Container>
    </section>
  );
}

export default HowToRegisterSection;
